import { Controller } from '@hotwired/stimulus'

const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
const LOAD_TIMEOUT_MS = 15000

export default class extends Controller {
  static values = { sitekey: String }

  connect () {
    this.#whenReady(() => this.#render())
  }

  disconnect () {
    if (this.widgetId && window.turnstile) window.turnstile.remove(this.widgetId)
    if (this.poll) clearInterval(this.poll)
    if (this.loadTimeout) clearTimeout(this.loadTimeout)
  }

  #render () {
    if (!window.turnstile) return
    this.widgetId = window.turnstile.render(this.element, {
      sitekey: this.sitekeyValue,
      'error-callback': () => {
        this.#showFallback()
        return true
      }
    })
  }

  #whenReady (callback) {
    if (window.turnstile) return callback()

    let script = document.querySelector(`script[src="${SCRIPT_SRC}"]`)
    if (!script) {
      script = document.createElement('script')
      script.src = SCRIPT_SRC
      script.async = true
      script.defer = true
      document.head.appendChild(script)
    }

    // Surface a fallback if the script never loads (blocked by CSP,
    // extensions, or a network issue) instead of polling forever.
    this.loadTimeout = setTimeout(() => {
      if (window.turnstile) return
      if (this.poll) clearInterval(this.poll)
      this.poll = null
      this.#showFallback()
    }, LOAD_TIMEOUT_MS)

    this.poll = setInterval(() => {
      if (window.turnstile) {
        clearInterval(this.poll)
        this.poll = null
        clearTimeout(this.loadTimeout)
        this.loadTimeout = null
        callback()
      }
    }, 100)
  }

  #showFallback () {
    if (this.fallbackShown) return
    this.fallbackShown = true

    const note = document.createElement('p')
    note.className = 'contact-form__error'
    note.innerHTML = 'Verification is having trouble loading. Please try again — or email us directly at <a href="mailto:hello@jetrockets.com">hello@jetrockets.com</a>.'
    this.element.insertAdjacentElement('afterend', note)
  }
}
